<template>
    <div>
        <Ending v-if="flatEndings" :submissions="endings[0].submissions" />
        <a-collapse v-else v-model="activeEndings" :bordered="false">
            <a-collapse-panel
                v-for="ending of endings" :key="ending.name"
                :header="ending.name"
            >
                <Ending :submissions="ending.submissions" />
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
import Ending from './Ending.vue'

export default {
    props: {
        endings: Array,
    },
    data: () => ({
        activeEndings: [],
    }),
    computed: {
        flatEndings() {
            if (this.endings.length === 1 && this.endings[0].name === '') {
                return true;
            } else {
                return false;
            }
        }
    },
    created() {
        this.activeEndings = this.endings
            .filter(e => (Number(e.fold) === 0))
            .map(e => e.name);
    },
    components: {
        Ending,
    },
}
</script>

<style>

</style>